export default function isPlainObject(obj) {
  if (obj === undefined || obj === null) return;
  return Object.getPrototypeOf(obj) === Object.prototype;
}